import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

interface AsideProps {
  children: ReactNode;
  asideOverflow?: string;
}

const Aside = ({ asideOverflow, children }: AsideProps) => {
  const asideRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (asideOverflow && asideRef.current)
      asideRef.current.style.overflowY = asideOverflow;
  }, [asideOverflow]);

  return (
    <aside className="Aside" ref={asideRef}>
      <div className="Aside-inner">{children}</div>
    </aside>
  );
};

export default Aside;
